import React from "react";
import AboutSection1 from "../../AboutPage/AboutSection1";
import Section2 from "../../AboutPage/AboutSection2";
// import AboutSection3 from "../../AboutPage/AboutSection3";
import AboutSection4 from "../../AboutPage/AboutSection4";
import AboutSection5 from "../../AboutPage/AboutSection5";
import AboutSection6 from "../../AboutPage/AboutSection6";

const AboutPage = () => {
  return (
    <>
      <AboutSection1 />

      <div id="section2">
        <Section2 />
      </div>
      <AboutSection4 />
      {/* <AboutSection3 /> */}
      <AboutSection6 />
      <AboutSection5 />
    </>
  );
};

export default AboutPage;
